import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../axiosInstance';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DataTableComponent from '../../common/DataTable/PrimeDataTable';
import { convertUTCToLocal } from '../../utils/dateUtils';

const CategoryOrganizations = ({ persona }) => {
  const { id } = useParams();
  const [t] = useTranslation();
  const [data, setData] = useState(null);
  const [organizationsData, setOrganizationsData] = useState([]);
  const [paginationParams, setPaginationParams] = useState({
    limit: 10,
    offset: 0,
    sortField: 'createdAt',
    sortOrder: -1,
  });

  const navigate = useNavigate();

  useEffect(() => {
    fetchCategoryOrganizations();
  }, [id, paginationParams]);

  const fetchCategoryOrganizations = async () => {
    const response = await axiosInstance
      .get(`${process.env.REACT_APP_SERVER_URL}/api/categories/${id}`, {
        withCredentials: true,
      })
      .catch((err) => {
        console.log(err);
      });

    console.log('Category Organizations Response:', response?.data);

    setData(response?.data);
    setOrganizationsData(response?.data?.organizations || []);
  };

  const onDataTableEvent = (event) => {
    setPaginationParams((prev) => ({
      ...prev,
      limit: event.rows,
      offset: event.first,
      sortField: event.sortField || prev.sortField,
      sortOrder: event.sortOrder || prev.sortOrder,
    }));
  };

  const columns = [
    {
      field: 'id',
      header: 'ID',
      sortable: true,
      body: (rowData) => rowData.id,
    },
    {
      field: 'name',
      header: t('Organization Name'),
      sortable: true,
      filter: true,
      body: (rowData) => rowData.name,
    },
    {
      field: 'type',
      header: t('Type'),
      sortable: true,
      filter: true,
      body: (rowData) => (
        <span className={`badge badge-info`}>{rowData.type}</span>
      ),
    },
    {
      field: 'userCount',
      header: t('No. of Users'),
      sortable: true,
      filter: true,
      body: (rowData) => rowData.userCount || 0,
    },
    {
      field: 'createdAt',
      header: t('createdAt'),
      sortable: true,
      filter: true,
      body: (rowData) => convertUTCToLocal(rowData.createdAt),
    },
  ];

  const actions = [
    {
      text: t('users'),
      color: 'primary',
      onClick: (row) =>
        navigate(`/${persona}/categories/${id}/organizations/${row.id}/users`, {
          state: { category: data, organization: row },
        }),
    },
  ];

  return (
    <div>
      <DataTableComponent
        data={organizationsData}
        columns={columns}
        actions={actions}
        totalRecords={organizationsData?.length}
        enableCreate={false}
        enablePagination={true}
        paginationParams={paginationParams}
        onDataTableEvent={onDataTableEvent}
        enableLazyLoading={false}
        enableExport={true}
        sectionName={`Organizations-${new Date().getDate()}-${new Date().getMonth() + 1}-${new Date().getFullYear()}-${new Date().getHours()}-${new Date().getMinutes()}`}
      />
    </div>
  );
};

export default CategoryOrganizations;
